import FooterComponent from "../components/FooterComponent"
import FreePolicyPageComponent from "../components/FreePolicyComponent"
import HeaderComponent from "../components/HeaderComponent"

const FreePolicyPage = () => {
    return (
        <>
            <HeaderComponent/>
            <div className="bg-white">
            <FreePolicyPageComponent/>
            </div>
            <FooterComponent/>
        </>
    )
}

export default FreePolicyPage